import {BUILTIN_COLORS, Desk, Employee, HibobResidence, KeyData, KeySnapshot, Office, WorkSite} from "./Model";
import {emptyHierarchy, HierarchyEmployee} from "../util/EmployeeHierarchy";
import {EmployeeVisitSheet} from "./EmployeeVisitStore";


export const emptyEmployee: Employee = {
    id: -1,
    email: '',
    fullName: '',
    siteId: -1,
    hibobId: '',
    hrEmployeeId: '',
    managerHibobId: null,
    deactivated: false,
};

export const emptySite: WorkSite = {
    id: -1,
    name: '',
    archived: false,
};

export const emptyResidence: HibobResidence & {workSite: WorkSite} = {
    workSite: emptySite,
    hibobOffice: null,
};

export const emptyHierarchyEmployee: HierarchyEmployee = {
    ...emptyEmployee,
    type: 'node',
    parent: emptyHierarchy(),
    neighbourhoods: [],
    teamPath: undefined,
    residence: emptyResidence,
    keys: [],
    assignedDesks: [],
    children: [],
    match: true,
    length: 1,
};

export const emptyOffice: Office = {
    id: -1,
    keyOfficeId: -1,
    name: '',
    disabled: false,
    timezone: '',
    hibobResidence: [],
    checkInsIntegrationEnabled: false,
    releezmeIntegrationEnabled: false,
};

export const emptyKeyData: KeyData = {
    id: -1,
    keyNumber: '',
    tags: [],
    history: [{
        id: -1,
        vault: {
            id: -1,
            name: 'Select vault',
            color: BUILTIN_COLORS.DEFAULT,
        },
        location: {type: 'with-vault'},
    }],
};

export const emptyKey: KeySnapshot = {
    key: emptyKeyData,
    historyRecord: emptyKeyData.history[0],
};

export const emptyDesk: Desk = {
    id: "-1",
    name: '',
    roomName: '',
};

export const emptyEmployeeVisitSheet: EmployeeVisitSheet = {
    rows: [],
    dates: [],
    length: 0,
};
